import React from "react"
import autobind from "class-autobind"
import CircularProgress from "material-ui/CircularProgress"
import ImageLoader from "../../../components/misc/ImageLoader"
import Face from "material-ui/svg-icons/image/tag-faces"
import BuildIcon from "material-ui/svg-icons/action/build"
import Clock from "material-ui/svg-icons/action/schedule"
import MapLoader from "../../map/MapLoader"
import { IUserDocument, IPunchDocument, ITimecard, ITimecardDay } from "../../../models"
import * as api from "../../../api"
import { amber500 } from "material-ui/styles/colors"
import strings from "../../../localization/strings"
import moment from "moment"
import * as timeHelper from "../../../helpers/timeHelper"
import AccountStore from "../../../stores/AccountStore"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import AppStateStore from "../../../stores/AppStateStore"
interface IProps {
    dayNum: number
    timecard: ITimecard
    imageS3Url: string
    dayData: ITimecardDay
}
interface IState {
    loading: boolean
    users: IUserDocument[]
    punches: IPunchDocument[]
}

export default class EquipmentWorkHistoryDrawerContent extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            users: [],
            punches: []
        }
        autobind(this)
    }

    componentDidMount() {
        this.loadData()
    }

    componentWillReceiveProps(nextProps: IProps) {
        nextProps.dayNum !== this.props.dayNum &&
            this.loadData()
    }

    loadData() {
        this.setState({ loading: true }, () => {
            const punchIds = []
            const userIds = []
            this.props.timecard.TimecardWeeks[0].Days[this.props.dayNum].PunchSets.forEach(timecardPunchSet => {
                const punchSet = this.props.timecard.FullPunchSets.find(i => i.Id === timecardPunchSet.Id)
                punchSet.PunchInId && !this.state.punches.find(item => item.Id === punchSet.PunchInId) &&
                    punchIds.push(punchSet.PunchInId)
                punchSet.PunchOutId && !this.state.punches.find(item => item.Id === punchSet.PunchOutId) &&
                    punchIds.push(punchSet.PunchOutId)
                !this.state.users.find(item => item.Id === punchSet.UserId) && !userIds.includes(punchSet.UserId) &&
                    userIds.push(punchSet.UserId)
            })

            punchIds.length === 0 && userIds.length === 0 ?
                this.setState({ loading: false }) :
                Promise.all([api.getManyPunches(punchIds), api.getManyUsers(userIds)]).then(res => {
                    this.setState({
                        loading: false,
                        punches: this.state.punches.concat(res[0].data),
                        users: this.state.users.concat(res[1].data)
                    })
                })
        })
    }

    getLevelLabel(hierarchyItemId) {
        if (hierarchyItemId) {
            const levelName = hierarchyHelper.getHierarchyItemNameByHierarchyId(hierarchyItemId)
            if (!levelName) return ""
            const showLevelName = levelName.length < 20 ? levelName : levelName.substr(0, 19) + "..."
            return (
                <span>
                    {hierarchyHelper.getHierarchyDefinitionNameByHierarchyId(hierarchyItemId)}: {showLevelName}
                </span>
            )
        } else if (AccountStore.getCurrentAccount()) {
            return (
                <span>
                    {strings.Account}: {AccountStore.getCurrentAccount().Name}
                </span>
            )
        } else {
            return ""
        }
    }

    render() {
        const { dayData } = this.props
        const { users } = this.state
        let timeInfo, hierarchyInfo
        if (dayData.TotalDurationInMinutes === 0) {
            timeInfo = strings.There_is_no_work_history
        } else {
            const totalHourAndMinutes = timeHelper.convertToHourAndMinute(dayData.TotalDurationInMinutes)
            timeInfo =
                (totalHourAndMinutes.hours > 0 ? totalHourAndMinutes.hours + "h  " : "") +
                (totalHourAndMinutes.minutes < 10 ? "0" + totalHourAndMinutes.minutes + "min" : totalHourAndMinutes.minutes + "min")
            const hierarchyIds = []
            dayData.PunchSets.forEach(timecardPS => {
                const punchSet = this.props.timecard.FullPunchSets.find(i => i.Id === timecardPS.Id)
                if (hierarchyIds.indexOf(punchSet.HierarchyItemId) === -1) {
                    hierarchyIds.push(punchSet.HierarchyItemId)
                }
            })
            if (hierarchyIds.length > 1) {
                hierarchyInfo = strings.Multiple_Locations
            } else {
                hierarchyInfo = this.getLevelLabel(hierarchyIds[0])
            }
        }
        return (
            <div style={{ textAlign: "center", paddingLeft: 120, paddingRight: 120, paddingTop: 35 }}>
                {this.state.loading ?
                    <CircularProgress /> :
                    <div style={{ position: "relative" }}>
                        <div style={{ width: 60, height: 60, borderRadius: "50%", border: "10px solid " + AppStateStore.getFrontEndSettings().UISettings.AccentColor }}>
                            {this.props.imageS3Url ?
                                <ImageLoader url={this.props.imageS3Url} fixedHeight={110} avatar={true} /> :
                                <BuildIcon style={{ fill: amber500, width: 50, height: 50, margin: 3 }} />
                            }
                            <div style={{ position: "absolute", top: 35, left: 125 }}>
                                <div style={{ textAlign: "left", fontSize: 17, fontWeight: 500 }}>
                                    {timeInfo}
                                </div>
                                <div>{hierarchyInfo}</div>
                            </div>
                        </div>
                        <div style={{ position: "absolute", top: 80, left: 35 }}>
                            {dayData.PunchSets.map((timecardPS, index) => {
                                const punchSet = this.props.timecard.FullPunchSets.find(i => i.Id == timecardPS.Id)
                                const employee = users.find((user) => user.Id === punchSet.UserId)
                                const totalHourAndMinutes = timeHelper.convertToHourAndMinute(punchSet.PunchDurationInMinutes)
                                const dayTimeInfo =
                                    (totalHourAndMinutes.hours > 0 ? totalHourAndMinutes.hours + "h  " : "") +
                                    (totalHourAndMinutes.minutes < 10 ? "0" + totalHourAndMinutes.minutes + "min" : totalHourAndMinutes.minutes + "min")
                                const punchInTime = moment(punchSet.PunchInTime)
                                const punchOutTime = moment(punchSet.PunchOutTime)
                                const employeeNameLabel = employee ? employee.FirstName + " " + employee.LastName : ""

                                const locations = []
                                let mapMessage = ""
                                if (punchSet.PunchInId) {
                                    const punch = this.state.punches.find((punch) => punch.Id === punchSet.PunchInId)
                                    if (punch) {
                                        const punchInDetail = punch.MetaData
                                        if (punchInDetail.Latitude !== 0 && punchInDetail.Longitude !== 0) {
                                            locations.push({
                                                lat: punchInDetail.Latitude,
                                                lng: punchInDetail.Longitude
                                            })
                                        } else {
                                            mapMessage = punch.DeviceId ? strings.No_GPS_Location : strings.No_Location_Data
                                        }
                                    }
                                }
                                if (punchSet.PunchOutId) {
                                    const punch = this.state.punches.find((punch) => punch.Id === punchSet.PunchOutId)
                                    if (punch) {
                                        const punchOutDetail = punch.MetaData
                                        if (punchOutDetail.Latitude !== 0 && punchOutDetail.Longitude !== 0)
                                            locations.push({
                                                lat: punchOutDetail.Latitude,
                                                lng: punchOutDetail.Longitude
                                            })
                                    }
                                }

                                return (
                                    <div
                                        key={index}
                                        style={{ position: "relative", marginBottom: 5 }}
                                    >
                                        <div style={{ width: 3, borderRight: "3px solid " + AppStateStore.getFrontEndSettings().UISettings.AccentColor, display: "inline-block", height: index === 0 ? 75 : 250 }} />
                                        <div style={{ display: "inline-block" }}>
                                            <div style={{ position: "absolute", left: 25, bottom: -160, backgroundColor: "#CFD8DC", width: 640, height: 210, textAlign: "left" }}>
                                                <div style={{ fontSize: 12, fontWeight: 500, position: "absolute", top: 11, left: 17 }}>
                                                    {this.getLevelLabel(punchSet.HierarchyItemId)} - {employeeNameLabel}
                                                </div>
                                                <div style={{ position: "absolute", left: 17, top: 47 }}>
                                                    <div style={{ width: 35, height: 35, borderRadius: "50%", border: "7px solid white" }}>
                                                        {employee && employee.ProfileImageS3Url ?
                                                            <ImageLoader
                                                                url={employee.ProfileImageS3Url}
                                                                fixedHeight={65}
                                                                avatar={true}
                                                                src={"/users/profileimage/" + employee.ProfileImageS3Url}
                                                            /> :
                                                            <Face style={{ fill: "#9E9E9E", width: 37, height: 37, margin: -1 }} />
                                                        }
                                                    </div>
                                                    <div style={{ position: "absolute", width: 165, top: -4, left: 59 }}>
                                                        <div style={{ fontSize: 12, marginBottom: 10 }}>
                                                            {strings.Hours_Worked}
                                                        </div>
                                                        <div style={{ fontSize: 30, marginBottom: 10, fontWeight: 100 }}>
                                                            {punchSet.PunchInId && punchSet.PunchOutId ? dayTimeInfo : strings.Missing}
                                                        </div>
                                                        <div>
                                                            <div style={{ display: "inline-block", width: 90 }}>
                                                                {strings.Punched_In}:
                                                            </div>
                                                            {punchSet.PunchInId ? punchInTime.format("hh") + ":" + punchInTime.format("mm") + " " + punchInTime.format("a") : ""}
                                                        </div>
                                                        <div>
                                                            <div style={{ display: "inline-block", width: 90 }}>
                                                                {strings.Punched_Out}:
                                                            </div>
                                                            {punchSet.PunchOutId ? punchOutTime.format("hh") + ":" + punchOutTime.format("mm") + " " + punchOutTime.format("a") : ""}
                                                        </div>
                                                    </div>
                                                    <div style={{ position: "absolute", top: 17, left: 550 }}>
                                                        <Clock style={{ fill: "white", width: 37, height: 37, margin: -1 }} />
                                                    </div>
                                                </div>
                                                <div style={{ width: 640, height: 75, position: "absolute", top: 150, backgroundColor: "#e7e7e7" }}>
                                                    {mapMessage &&
                                                        <span
                                                            style={{ position: "absolute", zIndex: 2000, left: 245, top: 25, fontSize: 15 }}>
                                                            {mapMessage}
                                                        </span>
                                                    }
                                                    {locations.length > 0 &&
                                                        <MapLoader locations={locations} />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <span style={{ width: 21, height: 21, backgroundColor: "#CFD8DC", position: "absolute", left: 16, bottom: -10, transform: "rotate(45deg)" }} />
                                        <span style={{ width: 9, height: 9, position: "absolute", left: -3, bottom: -7, borderRadius: "50%", border: "3px solid " + AppStateStore.getFrontEndSettings().UISettings.AccentColor }} />
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                }
            </div>
        )
    }
}